import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pop-up-register',
  templateUrl: './pop-up-register.component.html',
  styleUrls: ['./pop-up-register.component.scss']
})
export class PopUpRegisterComponent implements OnInit  {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

}
